import ScrollAnimation from "./ScrollAnimation.js";
class SmoothScroll {
  constructor() {
    this.DOM = {
      links: document.querySelectorAll("a[href^='#']"),
      // header: document.querySelector('#header'),
    };
    console.log("a");
    this.scrollAnimation = new ScrollAnimation({ duration: 1000 });
    this.#addEvent();
  }
  #addEvent() {
    for(const link of this.DOM.links) {
      if (!link.classList.contains("_no_scroll")) {
        link.addEventListener('click', this.#scroll.bind(this));
      }
    };
  }
  #scroll(e) {
    e.preventDefault();
    const targetId = e.target.closest('a').getAttribute("href");
    let targetY;
    if (targetId === "#top") {
      targetY = 0;
    } else {
      const targetElement = document.querySelector(targetId);
      const offsetTop = window.pageYOffset;// 現在のスクロール距離
      const rectTop = targetElement.getBoundingClientRect().top;// 画面上端から要素までの距離
      // const headerHeight = this.DOM.header.clientHeight;
      const buffer = 40;
      // targetY = rectTop + offsetTop - headerHeight - buffer;
      targetY = rectTop + offsetTop - buffer;
    }
    this.scrollAnimation.exeScroll({ target: { y: targetY } });
  }
}
export default SmoothScroll;